import React, { useEffect } from 'react'
import './App.css';
import { SpeedInsights } from "@vercel/speed-insights/react";
import Header from './Component/Header/Header';
import Footer from './Component/Footer/Footer';
import {BrowserRouter, useLocation} from "react-router-dom";
import { CartProvider } from '../src/Component/AddToCart/CartContext';
import WhatsAppButton from '../src/Component/WhatsAppButton/WhatsAppButton';
import ScrollToTop from './Component/ScrollToTopButton/ScrollToTop';
import { AuthProvider } from '../src/Component/firebase/AuthContext';
import DataProvider from "../src/Component/ProductCarousal1/DataProvider";
import NavigationMenu from './Component/NavigationMenu/NavigationMenu';
import AppRoutes from './routes/AppRoutes';
import BackgroundMusic from './Component/BackgroundMusic/BackgroundMusic';
import { HeaderProvider } from './Component/Header/HeaderProvider';
import Welcome from './Component/Welcome/Welcome';
import CustomerCare from './Component/CustomerCare/CustomerCare';
import { CollectionProvider } from './Component/DashboardProduct/GenericContext';
// import SimpleAlert from '../src/Component/SimpleAlert'
// import {BrowserRouter, Routes, Route, Link, NavLink, useLocation} from "react-router-dom";
// import Home from './Component/HomePage/Home';
// import Contact from './Component/Contact/Contact';
// import Cart from './Component/AddToCart/Cart';
// import RefundPolicy from './Component/TermsAndConditions/RefundPolicy';
// import PrivcyPolicy from './Component/TermsAndConditions/PrivacyPolicy';
// import TermsOfService from './Component/TermsAndConditions/TermsOfService';
// import ShippingPolicy from './Component/TermsAndConditions/ShippingPolicy';
// import ContactInformation from './Component/TermsAndConditions/ContactInformation';
// import Login from '../src/Component/Authentication/Login'
// import Register from '../src/Component/Authentication/Register'
// import Forgotpassword from './Component/Authentication/Forgotpassword'
// import Topcollections from './Component/Viewallproducts/Topcollections';
// import Electronicscollection from './Component/Viewallproducts/Electronicscollection';
// import Homeimprovement from './Component/Viewallproducts/Homeimprovement';
// import Checkout from './Component/Checkout/Checkout';
// import Productdetail from '../src/Component/Productdetail/Productdetail';
// import { AboutUs } from './Component/TermsAndConditions/AboutUs';
// import Receipt from '../src/Component/Receipt/Receipt';
// import SearchResults from './Component/SearchResults/SearchResults';



function Main() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();
  const renderHeaderAndFooter = ![
                                    '/login',
                                    '/register',
                                    '/forgotpassword',
                                    '/checkout',
                                    '/termsofservice',
                                    '/privcypolicy',
                                    '/contactinformation',
                                    '/refundpolicy',
                                    '/shippingpolicy',
                                    '/password_change',
                                  ].includes(location.pathname);

  return (
    <div className="page-container">
      {renderHeaderAndFooter && (
        <>
        {/* <SimpleAlert /> */}
        <HeaderProvider>
          <CollectionProvider  collectionNames={['featuredProduct', 'trendingProduct']}>
          <Header />
          </CollectionProvider>
        </HeaderProvider>
        {/* <Welcome /> */}
        <NavigationMenu />
        <SpeedInsights />
          
        </>
      )}

      {/* <CartProvider> */}
      <AuthProvider>
        <DataProvider>
          <AppRoutes />
          {/* <Routes>
            <Route path='/' Component={Home} />
            <Route path='/contact-us' Component={Contact} />
            <Route path='/cart' Component={Cart} />
            <Route path='/shopnow' Component={Cart} />
            <Route path='/ordernow' Component={Cart} />
            <Route path='/refundpolicy' Component={RefundPolicy} />
            <Route path='/privcypolicy' Component={PrivcyPolicy} />
            <Route path='/termsofservice' Component={TermsOfService} />
            <Route path='/shippingpolicy' Component={ShippingPolicy} />
            <Route path='/contactinformation' Component={ContactInformation} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/forgotpassword' element={<Forgotpassword />} />
            <Route path='/top_collections' Component={Topcollections} />
            <Route path='/electronics' Component={Electronicscollection} />
            <Route path='/home_improvement' Component={Homeimprovement} />
            <Route path='/checkout' Component={Checkout} />
            <Route path="/product_detail/:id" Component={Productdetail} />
            <Route path='/about-us' Component={AboutUs} />
            <Route path='/receipt' element={<Receipt />} />
            <Route path="/search-results" element={<SearchResults  />} />
          </Routes> */}
        </DataProvider>
      </AuthProvider>
      {/* </CartProvider> */}
        
      {renderHeaderAndFooter && (
         <>
         <ScrollToTop />
         {/* <CustomerCare /> */}
          <Footer/>
          
          <WhatsAppButton />
          {/* <BackgroundMusic /> */}
        </>
      )}
    </ div>
  );
}
function App() {
  return (
    <BrowserRouter>
    <AuthProvider>
        <CartProvider>
          <Main />
        </CartProvider>
    </AuthProvider>
      {/* <Main /> */}
    </BrowserRouter>
  );
}
export default App;







// import React, {useEffect, useState, useContext} from 'react'
// import './App.css';
// import Home from './Component/HomePage/Home';
// import Contact from './Component/Contact/Contact';
// import Cart from './Component/AddToCart/Cart';
// import {BrowserRouter, Routes, Route, Link, NavLink, useLocation} from "react-router-dom";
// import { CartProvider } from '../src/Component/AddToCart/CartContext';
// import shopit from '../src/Component/Images/shopit.png';
// import WhatsAppButton from '../src/Component/WhatsAppButton/WhatsAppButton';
// import RefundPolicy from './Component/TermsAndConditions/RefundPolicy';
// import PrivcyPolicy from './Component/TermsAndConditions/PrivacyPolicy';
// import TermsOfService from './Component/TermsAndConditions/TermsOfService';
// import ShippingPolicy from './Component/TermsAndConditions/ShippingPolicy';
// import ContactInformation from './Component/TermsAndConditions/ContactInformation';
// import facebookicon from '../src/Component/Images/facebookicon.png'
// import instagramicon from '../src/Component/Images/instagramicon.png'
// import tiktokicon from '../src/Component/Images/tiktokicon.png'
// import ourmissionicon from '../src/Component/Images/ourmissionicon.png'
// import contactusicon from '../src/Component/Images/contactusicon.png'
// import Login from '../src/Component/Authentication/Login'
// import Register from '../src/Component/Authentication/Register'
// import Forgotpassword from './Component/Authentication/Forgotpassword'
// import Topcollections from './Component/Viewallproducts/Topcollections';
// import Electronicscollection from './Component/Viewallproducts/Electronicscollection';
// import Homeimprovement from './Component/Viewallproducts/Homeimprovement';
// import Checkout from './Component/Checkout/Checkout';
// import Productdetail from '../src/Component/Productdetail/Productdetail';
// import { AboutUs } from './Component/TermsAndConditions/AboutUs';
// import coder from '../src/Component/Images/coder.png';
// import { AuthProvider } from '../src/Component/firebase/AuthContext';
// import Receipt from '../src/Component/Receipt/Receipt';
// import DataProvider from "../src/Component/ProductCarousal1/DataProvider";

// import { useAuth } from '../src/Component/firebase/AuthContext';
// import { useCart } from './Component/AddToCart/CartContext';
// import usericon from '../src/Component/Images/usericon.png';
// import addtocarticon from '../src/Component/Images/addtocarticon.png';
// import { DataContext } from '../src/Component/ProductCarousal1/DataProvider';
// import { useSelector } from "react-redux";
// import { topCollection, electronicCollection, homeImprovement } from '../src/Component/ProductCarousal1/data';
// import { doubleproductlistData1, doubleproductlistData2 } from '../src/Component/Only2ProductCarousal/data';
// import Searchproduct from '../src/Component/SearchProduct/Searchproduct';
// import SearchResults from './Component/SearchResults/SearchResults';

// import UserMenu from './Component/UserMenu/UserMenu'
// import Navbar from './Component/Navbar/Navbar';


// function Main() {

//   useEffect(() => {
//           window.scrollTo(0, 0);
//       }, []);

//   const location = useLocation();
//   const renderHeaderAndFooter = !['/login', '/register', '/forgotpassword', '/checkout', '/termsofservice', '/privcypolicy', '/contactinformation', '/refundpolicy', '/shippingpolicy'].includes(location.pathname);
//   const [isOpen, setIsOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsOpen(!isOpen);
//   }

//   const closeMenu = () => {
//     setIsOpen(false);
//   }
//   // useEffect(() => {
//   //   const handleResize = () => {
//   //     if (window.innerWidth > 768) {
//   //       setIsOpen(false); // Screen bari hone par navbar close ho jaye
//   //     }
//   //   };

//   //   window.addEventListener('resize', handleResize);
//   //   // Cleanup function taake memory leak na ho
//   //   return () => {
//   //     window.removeEventListener('resize', handleResize);
//   //   };
//   // }, []);

//     // const { cartItemCount } = useCart();
//     const { cartItemCount } = useCart();
//     console.log("Cart Item Count:", cartItemCount);

//     const { user, handleUserNavigation } = useAuth();

//     const {loading, loadingMore, loadMoreHomeImprovement, loadMoreElectronicCollection, loadMoreTopCollection, loadMoreOurCollection } = useContext(DataContext);
 
//   const {homeImprovement}= useSelector(
//   (state) => state.homeImprovement
//   );
//   const {electronicCollection}= useSelector(
//     (state) => state.electronicCollection
//     );
//   const {topCollection}= useSelector(
//     (state) => state.topCollection
//     );
//     const {ourCollection}= useSelector(
//       (state) => state.ourCollection
//       );
//     // const {homeImprovement}= useSelector(
//     //   (state) => state.homeImprovement
//     //   );


//   // Effect to automatically load more products when reaching the bottom of the page (optional)
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         if (entries[0].isIntersecting) {
//           loadMoreHomeImprovement();
//           loadMoreElectronicCollection();
//           loadMoreTopCollection();
//           loadMoreOurCollection();
//         }
//       },
//       { threshold: 1.0 }
//     );

//     // const bottomHomeImprovement = document.getElementById("homeImprovement-bottom");
//     // const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");
//     // const bottomTopCollection = document.getElementById("topCollection-bottom");


//     // if (bottomHomeImprovement) observer.observe(bottomHomeImprovement);
//     // if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);
//     // if (bottomTopCollection) observer.observe(bottomTopCollection);

//     // return () => {
//     //   if (bottomHomeImprovement) observer.unobserve(bottomHomeImprovement);
//     //   if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
//     //   if (bottomTopCollection) observer.unobserve(bottomTopCollection);
//     // };
//   }, [loading, loadingMore]);


//   {/* ------header container position fixed when search list is visible------- */}
//   const [isListVisible, setIsListVisible] = useState(false);
//   const handleListVisibilityChange = (visibility) => {
//     setIsListVisible(visibility);
//   };
//   {/* ------header container position fixed when search list is visible------- */}

//   return (
//     <>
//     {renderHeaderAndFooter && (
//       <>

//         {/* ------header position fixed when search list is visible------- */}
//         <header 
//           style={{ position: isListVisible ? 'fixed' : '', 
//                    top: 0, 
//                    width: '100%', 
//                    zIndex: 9999}}>
//           Welcome to our Official shopit Store 🔥
//         </header>
        
//         {/* ------header container position fixed when search list is visible------- */}
//         {/* <div className='header-container'> */}
//         <div className={`header-container ${isListVisible ? 'fixed' : ''}`}>
//           <Navbar
//            isOpen={isOpen}
//            toggleMenu={toggleMenu}
//            closeMenu={closeMenu}
//            isListVisible={isListVisible}
//           />
//           <div className='logo-container'>
//             <Link to="/" className='logo-link'>shopit🛍</Link>
//           </div>

//           <div className='search-product'>
//             <Searchproduct 
//               productData={[...topCollection,
//               ...electronicCollection,
//               ...homeImprovement, 
//               ...ourCollection, 
//               ...doubleproductlistData2]} 
//               // ------header container and header position fixed when search list is visible-------
//               onListVisibilityChange={handleListVisibilityChange} />
//           </div>

//           <div className='cart-login-icon'>
//             <Link to="/cart" className='cart-link'>
//               {cartItemCount > 0 && <span className="cart-count">{cartItemCount}</span>}
//               <img src={addtocarticon} 
//                    alt="AddtoCartIconError" 
//                    className='cart-icon'
//               />
//             </Link>

//             <img 
//               // src={usericon} 
//               src={user ? usericon : usericon}
//               alt="Login" 
//               onClick={(e) => {
//                 e.stopPropagation(); // Prevent triggering the product click event
//                 handleUserNavigation(); // Add the item to the cart
//               }} 
//               className='login-icon' 
//             />
//           </div>
//         </div>
        
//           <div className='nav-link-container'>
//             <NavLink to="/" className='nav-link'>Home</NavLink>
//             <NavLink to="/electronics" className='nav-link'>Electronics</NavLink>
//             <NavLink to="/home_improvement" className='nav-link'>Home Improvement</NavLink>
//             <NavLink to="/about-us" className='nav-link'>About Us</NavLink>
//             <NavLink to="/contact-us" className='nav-link'>Contact Us</NavLink>
//           </div>

//       </>
//     )}

//     {/* <CartProvider> */}
//     <AuthProvider>
//       <DataProvider>
//       <Routes>
//         <Route path='/' Component={Home} />
//         <Route path='/contact-us' Component={Contact} />
//         <Route path='/cart' Component={Cart} />
//         <Route path='/shopnow' Component={Cart} />
//         <Route path='/ordernow' Component={Cart} />
//         <Route path='/refundpolicy' Component={RefundPolicy} />
//         <Route path='/privcypolicy' Component={PrivcyPolicy} />
//         <Route path='/termsofservice' Component={TermsOfService} />
//         <Route path='/shippingpolicy' Component={ShippingPolicy} />
//         <Route path='/contactinformation' Component={ContactInformation} />
//         <Route path='/login' element={<Login />} />
//         <Route path='/register' element={<Register />} />
//         <Route path='/forgotpassword' element={<Forgotpassword />} />
//         <Route path='/top_collections' Component={Topcollections} />
//         <Route path='/electronics' Component={Electronicscollection} />
//         <Route path='/home_improvement' Component={Homeimprovement} />
//         <Route path='/checkout' Component={Checkout} />
//         <Route path="/product_detail/:id" Component={Productdetail} />
//         <Route path='/about-us' Component={AboutUs} />
//         <Route path='/receipt' element={<Receipt />} />
//         <Route path="/search-results" element={<SearchResults  />} />
//       </Routes>
//       </DataProvider>
//       </AuthProvider>
//     {/* </CartProvider> */}
        
//     {renderHeaderAndFooter && (
//       <>
//       <footer>
//         <div className='footer-container'>
//           <div className='ourmission-container'>
//             <h3>
//               <img src={ourmissionicon} alt="OurMissionIconError" />
//               Our Mission
//             </h3>
//             <p>Shopit is online shopping store that focuses on selling high quality products at low prices to customers.</p>
//           </div>

//           <div className='footer-logo-container'>
//           <Link to="/" className='logo-link' style={{marginLeft:'-2vmax'}}><img src={shopit} alt='error' /></Link>
//           </div>

//           <div className='contact-us-container'>
//             <h3>
//               <img src={contactusicon} alt="ContactUsIconError" />
//               Contact Us
//             </h3>
//             <p>
//               Email Address:<br/>
//               <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=new" target="_blank" rel="noopener noreferrer" style={{textDecoration:'none', color:'white'}}>
//                 muhammadaliraza340@gmail.com
//               </a>
//             </p>
//             <p>
//               Contact No:<br/>
//               +92-309-1416573
//             </p>
//           </div>
//         </div>

//           <div className='social-media-link-container'>
//             <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" style={{textDecoration:'none', color:'white'}}> 
//               <img src={facebookicon} alt="Facebook" />
//             </a>
//             <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" style={{textDecoration:'none', color:'white'}}>
//               <img src={instagramicon} alt="Facebook" />
//             </a>
//             <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer" style={{textDecoration:'none', color:'white'}}> 
//               <img src={tiktokicon} alt="Tiktok" style={{width:'50px', height:'53px',marginLeft:'-8px'}}/>
//             </a>
//           </div>

//           <p className='copyright'>© 2023, Copyright shopit®. All rights reserved.</p>

//           <div className='terms-and-conditions-container' >
//             <Link to="/refundpolicy" className='terms-and-condition-link' >
//               Refund Policy
//             </Link>
//             <Link to="/privcypolicy" className='terms-and-condition-link'>
//               Privacy Policy
//             </Link>
//             <Link to="/termsofservice" className='terms-and-condition-link'>
//               Terms of Service
//             </Link>
//             <Link to="/shippingpolicy" className='terms-and-condition-link'>
//               Shipping Policy
//             </Link>
//             <Link to="/contactinformation" className='terms-and-condition-link'>
//               Contact Information
//             </Link>
//             <br/><br/>
//           </div>
//           <p style={{
//               backgroundColor:'black',
//               fontSize: '1.5vmax',
//               marginBottom:"10px",
//               display:'flex',
//               justifyContent:'center',
//               alignItems:'center'
//               }}>
//             ❤️dac
//             <img src={coder} alt="developer" 
//               style={{width:'1.5vmax', height:'1.5vmax', marginLeft:'4px'}}/>
//           </p>
//           <br/>
//       </footer>
//       <WhatsAppButton />
//       </>
//     )}
    
//     </>
//   );
// }
// function App() {
//   return (
//     <BrowserRouter>
//     <AuthProvider>
//         <CartProvider>
//           <Main />
//         </CartProvider>
//     </AuthProvider>
//       {/* <Main /> */}
//     </BrowserRouter>
//   );
// }
// export default App;
